/* eslint-disable no-unused-vars */
import { useCallback, useMemo } from "react";
import { ISwapSecurity } from "@/lib/interfaces and Enums/ENUMSwapSecurity";
import { ReferenceDataStatus } from "@/lib/interfaces and Enums/ENUMReferenceDataStatus";
import swapSecuritiesStore from "@/store/swapSecuritiesStore";
import {
  findSwapSecurityByName,
  searchSwapSecurities,
} from "@/store/swapSecuritiesStoreACTIONS";
import { isTemplateAllowedForDirection } from "../helper/swapTemplateRule";
import { returnReferenceDataOptions } from "../helper/ticketSharedHelper";
import ReferenceDataSelect from "./ReferenceDataSelect";

// LQC-2939 - token search over the template swaps ("EUR 5Y", "GBP OIS"). Optional: a ticket
// can still be filled by hand, so a slow or failed load only disables this field.

interface ISwapTemplateSelect {
  value: string;
  // Swap passes its direction (spec F19); Swaption leaves it out, unfiltered.
  direction?: string;
  onSelect: (template: ISwapSecurity | undefined) => void;
  testId: string;
}

export function returnTemplatePlaceholder(status: ReferenceDataStatus): string {
  if (status === ReferenceDataStatus.Error) return "Templates unavailable";
  if (status === ReferenceDataStatus.Loaded) return "Search e.g. EUR 5Y ...";
  return "Loading templates ...";
}

const SwapTemplateSelect = ({
  value,
  direction = "",
  onSelect,
  testId,
}: ISwapTemplateSelect) => {
  const swapSecurities = swapSecuritiesStore((state) => state.swapSecurities);
  const status = swapSecuritiesStore((state) => state.swapSecuritiesStatus);

  const allowed = useMemo(
    () => swapSecurities.filter((item) => isTemplateAllowedForDirection(item, direction)),
    [swapSecurities, direction],
  );

  const searchOptions = useCallback(
    (term: string, limit: number) =>
      returnReferenceDataOptions(searchSwapSecurities(allowed, term, limit), (item) => ({
        label: item.securityName,
        value: item.securityName,
      })),
    [allowed],
  );

  return (
    <ReferenceDataSelect
      testId={testId}
      placeholder={returnTemplatePlaceholder(status)}
      selected={value ? { label: value, value } : null}
      searchOptions={searchOptions}
      isDisabled={status !== ReferenceDataStatus.Loaded}
      onSelect={(option) =>
        onSelect(option ? findSwapSecurityByName(option.value) : undefined)
      }
    />
  );
};

export default SwapTemplateSelect;
